export const environment = {
  production: false,
  apiUrl: 'https://sportiq-marketing-api.digi4dev.ma',
  baseDomain: 'sportiq-marketing.digi4dev.ma',
  devFederationSlug: 'frmtt',
  version: '1.0.9'
};
